import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="17"
		fill="none"
		viewBox="0 0 17 17"
		{...props}
	>
		{/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
		<path
			fill="var(--svg-color, currentColor)"
			stroke="var(--svg-color, currentColor)"
			fillRule="evenodd"
			strokeLinecap="round"
			strokeWidth="0.5"
			d="M6.168 13.374a.5.5 0 0 1-.042-.706L9.831 8.5 6.126 4.332a.5.5 0 0 1 .748-.664l4 4.5a.5.5 0 0 1 0 .664l-4 4.5a.5.5 0 0 1-.706.042"
			clipRule="evenodd"
		></path>
	</svg>
);

export { SvgComponent as Chevron };

const SkinnySvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="17"
		fill="none"
		viewBox="0 0 17 17"
		{...props}
	>
		{/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
		<path
			fill="var(--svg-color, currentColor)"
			stroke="var(--svg-color, currentColor)"
			fillRule="evenodd"
			strokeLinecap="round"
			strokeWidth="0.1"
			d="M6.168 13.374a.5.5 0 0 1-.042-.706L9.831 8.5 6.126 4.332a.5.5 0 0 1 .748-.664l4 4.5a.5.5 0 0 1 0 .664l-4 4.5a.5.5 0 0 1-.706.042"
			clipRule="evenodd"
		></path>
	</svg>
);

export { SkinnySvgComponent as SkinnyChevron };

const SmallSvgComponent = (props: SVGProps<SVGSVGElement>) => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="5"
		height="11"
		fill="none"
		viewBox="0 0 5 11"
		{...props}
	>
		{/* biome-ignore lint/style/useSelfClosingElements: <explanation> */}
		<path
			fill="var(--svg-color, currentColor)"
			fillRule="evenodd"
			d="M.168 10.374a.5.5 0 0 1-.042-.706L3.831 5.5.126 1.332A.5.5 0 0 1 .874.668l4 4.5a.5.5 0 0 1 0 .664l-4 4.5a.5.5 0 0 1-.706.042"
			clipRule="evenodd"
		></path>
	</svg>
);

export { SmallSvgComponent as ChevronSmall };
